import React from 'react';
import styles from './App.module.css';
import { Routes, Route, Navigate,  } from 'react-router-dom';
import Hero from './Componets/Hero/Hero';
import Pricing from './Componets/Pricing/Pricing';
import Home from './Componets/Home';
import Navbar from './Componets/Navbar/Navbar';

const App = () => {
  return (
    <>
    <div className={styles.appContainer}>
      <Navbar />
       <Home />

      
      <Routes>


      </Routes>
      
    </div>
    </>
  );
};

export default App;